/**
 * CA Auth OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserItemDto } from './userItemDto.model';


export interface ListResponseUserItemDto { 
    itemCount?: number;
    items?: Array<UserItemDto>;
    params?: { [key: string]: any; };
}

